import { render, staticRenderFns } from "./company-form.vue?vue&type=template&id=32a3615a&lang=html&"
import script from "./company-form.vue?vue&type=script&lang=js&"
export * from "./company-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports